import _extends from "@babel/runtime/helpers/extends";
import { AcornsIcon } from '@acorns/icons';
import React from 'react';
import { BadgeIcon, BodyContainer, SkipButton, SkipIcon, LearnTipTitle, StyledBadge, TopContainer, LearnTipBodyContent, BodyCTA } from './styled-components';
export var LearnTipContent = function LearnTipContent(_ref) {
  var step = _ref.step,
      skipProps = _ref.skipProps,
      handleClose = _ref.handleClose;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TopContainer, {
    backgroundImageUrl: step.backgroundImageUrl
  }, step.badgeIcon && /*#__PURE__*/React.createElement(BadgeIcon, {
    icon: step.badgeIcon
  }), step.badgeText && !step.badgeIcon && /*#__PURE__*/React.createElement(StyledBadge, {
    badgeColor: step.badgeColor
  }, step.badgeText), /*#__PURE__*/React.createElement(SkipButton, _extends({}, skipProps, {
    onClick: handleClose || skipProps.onClick,
    "data-testid": "".concat(step.dataTestId, "_close_button"),
    skipButtonColor: step.skipButtonColor
  }), /*#__PURE__*/React.createElement(SkipIcon, {
    icon: step.skipButtonIcon || AcornsIcon.Icon.CloseXIcon,
    height: 12,
    width: 12
  }))), /*#__PURE__*/React.createElement(BodyContainer, {
    hasBottomPadding: !step.showButtons
  }, step.title && /*#__PURE__*/React.createElement(LearnTipTitle, null, step.title), step.content && /*#__PURE__*/React.createElement(LearnTipBodyContent, null, step.content), step.bodyCTAText && /*#__PURE__*/React.createElement(BodyCTA, {
    onClick: step.handleBodyCTA
  }, step.bodyCTAText)));
};